import { GQLLookFor } from 'generated-graphql/graphql'

export const hasSectionGoal = (
  lookForGender: string[],
  currentUserGender: string,
  lgbtRestriction?: boolean
) => {
  return (
    !lgbtRestriction ||
    (lgbtRestriction &&
      !lookForGender.includes(currentUserGender as unknown as GQLLookFor))
  )
}
